import { NotificationController } from 'core-components/library/popup'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { Rest } from 'src/core/classes/http'
import { IStorageVersion } from 'src/core/classes/models/IStorageVersion'

interface IVersionFetchResult {
  items: IStorageVersion[]
  error: boolean
}

class VersionApi {
  public getAPIVersions = async (): Promise<IVersionFetchResult> => {
    const url = proxyIdentity('/mbe/api/v1/app/data/versions')

    try {
      const items = await Rest.post({ url })
      return { items, error: false }
    } catch (err) {
      NotificationController.showError({ message: err as string })
    }
    return { items: [], error: true }
  }

  public updateVersionByAPI = async (key: string): Promise<IStorageVersion> => {
    const url = proxyIdentity(`/mbe/api/v1/app/data/versions/${key}`)
    return Rest.post({ url })
  }

  public deleteVersionByAPI = async (key: string): Promise<boolean> => {
    const url = proxyIdentity(`/mbe/api/v1/app/data/versions/${key}`)
    try {
      await Rest.delete({ url, identityToken: true })
      return true
    } catch (err: unknown) {
      NotificationController.showError({ message: err as string })
    }
    return false
  }
}

export default new VersionApi()
